import { Components, Theme } from '@mui/material/styles'

const components: Components<Theme> = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '1rem',
        padding: '10px 24px',
        boxShadow: 'none',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },
      },
      sizeLarge: {
        padding: '14px 32px',
        fontSize: '1.125rem',
      },
      sizeSmall: {
        padding: '6px 16px',
        fontSize: '0.875rem',
      },
      contained: {
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },
      },
      outlined: {
        borderWidth: 2,
        '&:hover': {
          borderWidth: 2,
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        transition: 'box-shadow 0.3s ease, transform 0.3s ease',
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 24,
        '&:last-child': {
          paddingBottom: 24,
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 8,
        },
      },
    },
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        '&:before': {
          display: 'none',
        },
        '&:first-of-type': {
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        },
        '&:last-of-type': {
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
        },
        '&.Mui-expanded': {
          margin: '8px 0',
        },
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        padding: '16px 24px',
        minHeight: 64,
        '&.Mui-expanded': {
          minHeight: 64,
        },
      },
      content: {
        margin: '12px 0',
        '&.Mui-expanded': {
          margin: '12px 0',
        },
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        padding: '0 24px 24px',
      },
    },
  },
  MuiContainer: {
    styleOverrides: {
      root: {
        '@media (min-width: 1200px)': {
          maxWidth: 1400,
        },
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        scrollBehavior: 'smooth',
      },
      '*': {
        margin: 0,
        padding: 0,
      },
      'html, body, #root': {
        height: '100%',
      },
    },
  },
}

export default components
